<template><!-- svgo-optimised -->
<svg class="icon icon__minus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 12H4" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg></template>